import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { StateKey } from '@angular/platform-browser';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SsrTransferStateService {

  private isServer: boolean;

  constructor(
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.isServer = isPlatformServer(this.platformId);
  }

  public get<T>(baseString: string, stream$: Observable<T>): Observable<T> {
    const key = `${baseString}-ITEMS`;
    const stateKey = makeStateKey(key);
    const serverResult = this.getTransferState<T>(stateKey);
    if (serverResult) {
      this.removeTransferState(stateKey);
      return of(serverResult);
    }
    return stream$.pipe(map(items => this.setTransferState(stateKey, items)));
  }

  private getTransferState<T>(stateKey: StateKey<T>) {
    return this.transferState.get<T>(stateKey, null);
  }

  private setTransferState<T>(stateKey: StateKey<T>, value: T): T {
    if (this.isServer) {
      this.transferState.set(stateKey, value);
    }
    return value;
  }

  private removeTransferState<T>(stateKey: StateKey<T>) {
    this.transferState.set(stateKey, null);
  }

}
